import Modal from '../../modal'
import HTML from '../../html'
import { validateInput } from '../../utils'

export default class InterestForm {

    constructor(blockRoot, propIs) {
        this.root = blockRoot

        this.buttons = {
            interestForm: this.root.find('a'),
        }

        var getProjektRokPicker = () => {
            let min = Number.parseInt(this.buttons.interestForm.data('projekt-minrooms')) || 1
            let max = Number.parseInt(this.buttons.interestForm.data('projekt-maxrooms')) || 5

            let rooms = max - min + 1
            let roomsArr = Array.from(new Array(rooms).keys()).map((e, i) => i + min)

            return HTML('div')
                .classes('cform__rok-picker')
                .append(
                    HTML('h5').classes('cform__subtitle').content('Jag är intresserad av:'),
                    roomsArr.map(n => {
                        return HTML('label')
                            .classes('cform__checkbox')
                            .on('click', (event, element) => {
                                element.firstChild.checked ? $(element).addClass('selected') : $(element)
                                    .removeClass('selected')
                            })
                            .append(HTML('span').content(`${n} ROK`))
                            .prepend(
                                HTML('input')
                                    .attr({
                                        type: 'checkbox',
                                        name: 'rok',
                                        value: n,
                                    }),
                            )
                    }),
                )
                .render()
        }

        this.interestForm = new Modal()
        this.licenseForm = new Modal()
        this.licenseForm.defineContent($('.auxilary .agreement-policy').clone())
        let svgIcon = `<svg width="63" height="133" viewBox="0 0 63 133" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7242 0H0V133H23.7242C26.1216 133 28.3243 131.68 29.4553 129.567L61.5604 69.5666C62.5855 67.6507 62.5855 65.3493 61.5604 63.4334L29.4554 3.43338C28.3243 1.3196 26.1216 0 23.7242 0Z"/>
                        </svg>`

        var interestForm =
            HTML('form')
                .classes('cform ' + this.buttons.interestForm.data('property-category'))
                .on('submit', (event, form) => {
                    event.preventDefault()
                    this.send(event, form)
                })
                .append(
                    HTML('div')
                        .classes('cform__wrapper')
                        .append(
                            HTML('h2')
                                .classes('cform__header')
                                .content('Intresseanmälan'),
                            HTML('div')
                                .classes('cform__property-title')
                                .append(
                                    HTML('h3')
                                        .content(this.buttons.interestForm.data('property-title')),
                                    HTML('span')
                                        .classes('icon')
                                        .content(svgIcon)
                                ),
                            HTML('div')
                                .classes('trow')
                                .append(
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Förnamn*'),
                                            HTML('input').attr({
                                            'data-validation': 'text',
                                            type: 'text',
                                            name: 'firstname',
                                            })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Efternamn*'),
                                            HTML('input').attr({
                                            'data-validation': 'text',
                                            type: 'text',
                                            name: 'lastname',
                                        })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Telefon*'),
                                            HTML('input').attr({
                                            'data-validation': 'phone',
                                            type: 'text',
                                            name: 'phone',
                                        })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('E-Post*'),
                                            HTML('input').attr({
                                            'data-validation': 'email',
                                            type: 'email',
                                            name: 'email',
                                        })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Postnummer*'),
                                            HTML('input').attr({
                                            'data-validation': 'number',
                                            type: 'text',
                                            name: 'postnumber',
                                        })),
                                ),
                            propIs.projekt ? getProjektRokPicker() : null,
                            HTML('div')
                                .classes('cform__message')
                                .append(
                                    HTML('label')
                                        .content('Meddelande'),
                                    HTML('textarea').attr({
                                    name: 'message',
                                })),
                            HTML('label')
                                .classes('cform__checkbox')
                                .on('click', (event, element) => {
                                    if (element.firstChild.checked) {
                                        $(element).parents('form').find('.cform__submit').addClass('legit')
                                        $(element).addClass('selected')
                                    } else {
                                        $(element).parents('form').find('.cform__submit').removeClass('legit')
                                        $(element).removeClass('selected')
                                    }
                                })
                                .append(HTML('span').content('Jag godkänner '))
                                .prepend(
                                    HTML('input')
                                        .attr({
                                            type: 'checkbox',
                                            name: 'policy_accepted',
                                            value: 'accept',
                                        }),
                                )
                                .append(
                                    HTML('a')
                                        .attr({
                                            href: 'https://www.credentia.se/uploads/2018/05/dataskyddspolicy_credentia.pdf',
                                            target: '_blank',
                                        })
                                        .content('dataskyddspolicy enligt GDPR'),
                                    // .on("click", event => {
                                    //   event.preventDefault();
                                    //   this.licenseForm.show();
                                    // })
                                ),
                        ),
                    HTML('button')
                        .classes('cform__submit')
                        .attr({ type: 'submit' })
                        .content('Skicka'),
                )
                .render()

        this.interestForm.defineContent(interestForm)

        this.buttons.interestForm.on('click', event => {
            event.preventDefault()
            this.interestForm.show()
        })
    }

    send(submitEvent, form) {
        var valid = [true]
        var f = form.elements
        for (let i = 0, input; input = f[i++];) {
            if (input.dataset.validation || input.hasAttribute('required')) {
                valid.push(validateInput(input, input.dataset.validation))
            }
        }

        var validity = valid.reduce((res, status) => !res ? res : status)

        if (!validity) {
            return validity
        }

        var wait = new Modal()
        wait.defineContent(
            HTML('h1').content('Vi skickar ditt meddelande. Vänta lite…'),
            HTML('div').classes('generic-preloader').append(
                HTML('i').classes('fa fa-spinner'),
            ),
        )
        wait.on('hide:end', () => {
            wait.destroy()
        })
        this.interestForm.hide()
        wait.show()

        var start = (new Date()).getTime() / 1000

        $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'sendMailToVitec',
                form: $(submitEvent.target).serialize(),
                guid: $('article.single-property').data('property-guid'),
                wpid: $('article.single-property').data('property-wpid'),
                proptype: $('article.single-property').data('property-type'),
            },
            success: response => {
                var successfulRequest = true
                if (!response || !response.vitecResponse || response.vitecResponse.SendInterestForObjectResult !== 'OK') {
                    successfulRequest = false
                    var problem = new Modal()
                    problem.defineContent(
                        HTML('h1').content('Det blev ett problem'),
                        HTML('h2')
                            .content('Försök igen eller kontakta oss via telefon eller e-post. Vi ber om ursäkt för detta besväret.'),
                        HTML('a')
                            .attr({ href: '#' })
                            .content('Prova en gång till')
                            .on('click', e => {
                                e.preventDefault()
                                problem.hide()
                                this.interestForm.show()
                            }),
                    )
                    problem.on('hide:end', () => {
                        problem.destroy()
                    })
                    wait.hide()
                    problem.show()
                }

                if (typeof response.start !== 'undefined') {
                    var requestTime = ((new Date()).getTime() / 1000) - start
                    var vitecTime = response.end - response.start
                    $.ajax({
                        url: ajaxurl,
                        method: 'POST',
                        data: {
                            action: 'logVitecResponse',
                            timestamp: start,
                            formData: $(submitEvent.target).serialize(),
                            vitecResponse: response.vitecResponse.SendInterestForObjectResult,
                            guid: $('article.single-property').data('property-guid'),
                            wpid: $('article.single-property').data('property-wpid'),
                            requestSuccessful: true,
                            requestTotalTime: requestTime,
                            vitecTime: vitecTime,
                            credentiaOnlyTime: requestTime - vitecTime,
                        },
                    })
                }

                var thanks = new Modal()
                thanks.defineContent(
                    HTML('h1').content('Ditt meddelande har skickats.'),
                    HTML('h2').content('Tack för din intresseanmälan!'),
                )
                thanks.on('show:end', () => {
                    setTimeout(() => {
                        thanks.hide()
                    }, 2400)
                })
                thanks.on('hide:end', () => {
                    thanks.destroy()
                })
                wait.hide()
                thanks.show()
            },
            error: function(jqXHR, code, message) {
                var requestTime = ((new Date()).getTime() / 1000) - start
                $.ajax({
                    url: ajaxurl,
                    method: 'POST',
                    data: {
                        action: 'logVitecResponse',
                        timestamp: start,
                        formData: $(submitEvent.target).serialize(),
                        guid: $('article.single-property').data('property-guid'),
                        wpid: $('article.single-property').data('property-wpid'),
                        requestSuccessful: false,
                        requestTotalTime: requestTime,
                        failureMessage: message,
                    },
                })
            },
        })
    }

}
